var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "act_more",
    d: "M20.8087 3.08435L20.8086 3.08438L12.7882 11.0882C11.7389 12.1374 10.0316 12.1373 8.9819 11.0876L0.962004 3.08438L1.22689 2.81893L0.962 3.08437C0.737509 2.86034 0.625114 2.5657 0.625114 2.27228C0.625114 1.9797 0.736851 1.68573 0.960329 1.46185C1.40791 1.01335 2.13428 1.01265 2.58277 1.46016L2.58278 1.46018L10.6035 9.46425L10.6038 9.46452C10.7592 9.61995 11.0117 9.61958 11.1662 9.4651L11.1665 9.46482L19.1878 1.46018L19.1878 1.46016C19.6363 1.01264 20.3627 1.01335 20.8103 1.46187L20.8087 3.08435ZM20.8087 3.08435C21.2571 2.63674 21.2579 1.91036 20.8103 1.4619L20.8087 3.08435Z",
    fill: "#1E3799",
    stroke: "#1E3799",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActMore);
export default __webpack_public_path__ + "static/media/act_more.53392e97ae6841ab1d88e896abd3cf38.svg";
export { ForwardRef as ReactComponent };